import { Language } from '../language-selector/LanguageSelector';
import { FooterRowWebsiteLinks } from './FooterRowWebsiteLinks';
import { FooterRowPolicyLinks } from './FooterRowPolicyLinks';

import './Footer.scss';

export interface FooterProps {
    advantageKey?: string;
    disableWishlist?: boolean;
    gacEnabled?: boolean;
    hasLinkedCards?: boolean;
    isAuthenticated?: boolean;
    isConsortium?: boolean;
    isDlr?: boolean;
    isGdprCountry?: boolean;
    isGhostLoginEnabled?: boolean;
    languages?: Language[];
    libraryHomeUrl?: string;
    libraryKey: string;
    libraryName: string;
    librarySupportEmail?: string;
    librarySupportUrl?: string;
    ntcMode?: boolean;
    onLanguageChange?: (language?: Language) => void;
    openLinksInNewWindow?: boolean;
    optimizeForChina?: boolean;
    parentAccountKey?: string;
    sampleOnlyMode?: boolean;
    showCookieBanner?: boolean;
    showCookieSettingsModal?: boolean;
    showHolds?: boolean;
    showKindlePromo?: boolean;
    showLibbyPromo?: boolean;
    showOverDriveWindowsLink?: boolean;
    showSoraPromo?: boolean;
    showReadingHistory?: boolean;
    simplifiedNavigationBar?: boolean;
    socialFacebookUrl?: string;
    socialPinterestUrl?: string;
    socialTwitterUrl?: string;
    socialYouTubeUrl?: string;
}

export const Footer = ({
    advantageKey,
    disableWishlist,
    gacEnabled,
    hasLinkedCards,
    isAuthenticated,
    isConsortium,
    isDlr,
    isGdprCountry,
    isGhostLoginEnabled,
    languages,
    libraryHomeUrl,
    libraryKey,
    libraryName,
    librarySupportEmail,
    librarySupportUrl,
    ntcMode,
    onLanguageChange,
    openLinksInNewWindow,
    optimizeForChina,
    parentAccountKey,
    sampleOnlyMode,
    showCookieBanner,
    showCookieSettingsModal,
    showHolds,
    showKindlePromo,
    showLibbyPromo,
    showOverDriveWindowsLink,
    showSoraPromo,
    showReadingHistory,
    simplifiedNavigationBar,
    socialFacebookUrl,
    socialPinterestUrl,
    socialTwitterUrl,
    socialYouTubeUrl,
}: FooterProps) => (
    <footer className="footer--new">
        <FooterRowWebsiteLinks
            disableWishlist={disableWishlist}
            gacEnabled={gacEnabled}
            hasLinkedCards={hasLinkedCards}
            isAuthenticated={isAuthenticated}
            isConsortium={isConsortium}
            isDlr={isDlr}
            libraryHomeUrl={libraryHomeUrl}
            libraryKey={libraryKey}
            libraryName={libraryName}
            librarySupportEmail={librarySupportEmail}
            librarySupportUrl={librarySupportUrl}
            ntcMode={ntcMode}
            openLinksInNewWindow={openLinksInNewWindow}
            optimizeForChina={optimizeForChina}
            sampleOnlyMode={sampleOnlyMode}
            showHolds={showHolds}
            showKindlePromo={showKindlePromo}
            showLibbyPromo={showLibbyPromo}
            showOverDriveWindowsLink={showOverDriveWindowsLink}
            showSoraPromo={showSoraPromo}
            showReadingHistory={showReadingHistory}
            simplifiedNavigationBar={simplifiedNavigationBar}
            socialFacebookUrl={socialFacebookUrl}
            socialPinterestUrl={socialPinterestUrl}
            socialTwitterUrl={socialTwitterUrl}
            socialYouTubeUrl={socialYouTubeUrl}
        />

        <FooterRowPolicyLinks
            advantageKey={advantageKey}
            isAuthenticated={isAuthenticated}
            isGdprCountry={isGdprCountry}
            isGhostLoginEnabled={isGhostLoginEnabled}
            languages={languages}
            ntcMode={ntcMode}
            onLanguageChange={onLanguageChange}
            openLinksInNewWindow={openLinksInNewWindow}
            optimizeForChina={optimizeForChina}
            parentAccountKey={parentAccountKey}
            showCookieBanner={showCookieBanner}
            showCookieSettingsModal={showCookieSettingsModal}
        />
    </footer>
);

export default Footer;
